<p-toast [style]="{marginTop: '80px'}"></p-toast>
<div class="p-2">
  @if (formLoading) {
    <div class="progress-spinner">
      <app-spinner [formLoading]="formLoading"></app-spinner>
    </div>
  }

  <h2>Travel Insurance Report</h2>


  @if (showSearchUI) {
    <app-search-template searchLabel="Search" [showSearchButton]="true" [reset]="false"
      [showLocations]="false" [showDevelopments]="false" [showShortTermRentals]="false" [showRateBuckets]="false"
      [showBedrooms]="false" [showSeasons]="false" [showReservationStatuses]="false" [showStartDate]="false"
      [showEndDate]="false" [showSaleDateStart]="true" [saleDateStart]="defaultStartDate" [saleDateEnd]="defaultEndDate"
      [showSaleDateEnd]="true" [showSaleYear]="false" [displayRecordsOnPageLoad]="false" [defaultEndDate]="defaultEndDate"
      [defaultShortTermRentalIds]="defaultShortTermRentalIds" [showBlankStartAndEndDate]="false"
      [showReferralSources]="false" [showResTypes]="false" [startDateLabel]="'Check-In Date'"
      [endDateLabel]="'Check-Out Date'" [defaultReservationStatuses]="defaultReservationStatuses"
    (doSearchCB)="onSearchSubmit($event)"></app-search-template>
  }
  <br>
    <div class="d-flex justify-content-end align-items-center mb-2">
      <p-splitButton appendTo="body" label="Export" icon="pi pi-download" [model]="exportItems">
      </p-splitButton>
    </div>
    <br>

      <ag-grid-angular style="width: auto; height: 70vh;" class="ag-theme-balham" [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        [rowData]="travelInsuranceReportData" (gridReady)="onGridReady($event)"
        (firstDataRendered)="onFirstDataRendered($event)" (rowGroupOpened)="onRowGroupOpened($event)"
        [defaultColDef]="defaultColDef">
      </ag-grid-angular>
    </div>
